export default __webpack_public_path__ + "static/media/REEF.406bab47.svg";